/* global debounce */

if (!window.kexSearchSemantic) {
  window.kexSearchSemantic = {
    normalize(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    },

    academyFamilies: [
      {
        matches: [/(\b|^)recet/],
        expansions: ['receta', 'recetas', 'recetario', 'recetarios']
      },
      {
        matches: [/\bcomo hacer\b/, /\bcomo preparar\b/, /\bprepar/, /\bhacer\b/, /\btutorial\b/, /\bpaso a paso\b/, /\bguia\b/],
        expansions: ['como hacer', 'como preparar', 'preparar', 'tutorial', 'paso a paso', 'guia', 'guía']
      },
      {
        matches: [/\bnavid/],
        expansions: ['navidad', 'navideña', 'navidena', 'navideño', 'navideno', 'navideñas', 'navidenas', 'navideños', 'navidenos']
      },
      {
        matches: [/\btemporad/, /\bestacional\b/, /\bfestiv/, /\bfiesta/],
        expansions: ['temporada', 'temporadas', 'estacional', 'estacionales', 'festivo', 'festiva']
      },
      {
        matches: [/\blatte\b/, /\bmocha\b/, /\bchai\b/, /\bcapuccino\b/, /\bcapuccino\b/, /\bbebida\b/, /\bbebidas\b/],
        expansions: ['latte', 'mocha', 'chai', 'bebida', 'bebidas']
      },
      {
        matches: [/\bbubble\b/, /\bboba\b/, /\bperlas\b/, /\btapioca\b/, /\bpopping\b/],
        expansions: ['bubble tea', 'boba', 'perlas', 'tapioca', 'popping boba']
      }
    ],

    catalogFamilies: [
      {
        matches: [/\bjarab/, /\bsyrup/, /\bsirop/, /\bsaborizant/],
        expansions: ['jarabe', 'jarabes', 'syrup', 'saborizante']
      },
      {
        matches: [/\bbase\b/, /\bbases\b/, /\bfrap/, /\bpolvo\b/, /\bpolvos\b/, /\bsmoothie/, /\besmuti/, /\bmalteada/, /\bmilkshake/],
        expansions: ['base', 'bases', 'frappé', 'frappe', 'polvo para bebida', 'base para bebidas', 'smoothie']
      },
      {
        matches: [/\bsalsa\b/, /\bsalsas\b/, /\btopping/, /\bcobertura/, /\bgolden dip\b/],
        expansions: ['salsa', 'salsas', 'topping', 'toppings', 'golden dip']
      },
      {
        matches: [/\btea\b/, /\bte\b/, /\bt[eé]\b/, /\btisana/, /\binfusion/, /\binfusi[oó]n/, /\beuro ?te\b/],
        expansions: ['tea', 'té', 'tisana', 'tisanas', 'infusión', 'euro té']
      },
      {
        matches: [/\bconcentrad/, /\bpur[eé]\b/, /\bpuree\b/, /\bpulpa/],
        expansions: ['concentrado', 'concentrados', 'puré', 'puree']
      },
      {
        matches: [/\bdesechable/, /\bvaso/, /\btapa/, /\bpopote/, /\bpajilla/, /\bstraw\b/, /\bsorbete/, /\bcuchar/, /\bcontenedor/],
        expansions: ['desechables', 'vasos', 'tapas', 'popotes', 'soluciones prácticas']
      },
      {
        matches: [/\bda ?vinci/, /\bdavinchi/, /\bdabinci/],
        expansions: ['davinci', 'jarabe davinci', 'base davinci']
      },
      {
        matches: [/\bbig ?tra?in/, /\bbigtrain/],
        expansions: ['big train', 'base big train']
      },
      {
        matches: [/\boregon/, /\bchai\b/],
        expansions: ['oregon chai', 'chai', 'chai latte']
      },
      {
        matches: [/\btea ?zone/, /\bteazone/, /\bbubble/, /\bboba/, /\bperla/, /\btapioca/, /\bpopping/],
        expansions: ['tea zone', 'bubble tea', 'perlas', 'tapioca', 'popping boba']
      },
      {
        matches: [/\bisland ?oasis/, /\bisland\b/],
        expansions: ['island oasis', 'concentrado']
      },
      {
        matches: [/\bbest ?whip/, /\bcrema batida/, /\bcarga/, /\bnitro/, /\bsif[oó]n/, /\bwhip/],
        expansions: ['best whip', 'crema batida', 'cargas', 'sifón']
      },
      {
        matches: [/\bcaf[eé]\b/, /\bcoffee/, /\bgrano/, /\bespresso/, /\bexpres/, /\bcapuc/, /\bcappuc/],
        expansions: ['café', 'coffee', 'grano', 'espresso']
      },
      {
        matches: [/\bequipo/, /\blicuadora/, /\bblender/, /\bm[aá]quina/, /\bsellador/, /\bbatidora/],
        expansions: ['equipo', 'equipos para cafetería', 'licuadora', 'blender', 'sellador']
      },
      {
        matches: [/\bvainil/, /\bvanil/, /\bbainil/],
        expansions: ['vainilla', 'vanilla']
      },
      {
        matches: [/\bchocol/, /\bchoco\b/, /\bcocoa/, /\bmocha\b/, /\bmoka\b/],
        expansions: ['chocolate', 'cocoa', 'mocha']
      },
      {
        matches: [/\bcaram/, /\bcajeta/, /\bdulce de leche/],
        expansions: ['caramelo', 'caramel', 'cajeta']
      },
      {
        matches: [/\bfres[ai]/, /\bstrawberr/, /\bfrutilla/],
        expansions: ['fresa', 'strawberry']
      },
      {
        matches: [/\bmatch?a\b/, /\bmacha\b/],
        expansions: ['matcha', 'té verde']
      },
      {
        matches: [/\btaro\b/],
        expansions: ['taro']
      },
      {
        matches: [/\bmaracu/, /\bpassion/, /\bparchita/],
        expansions: ['maracuyá', 'passion fruit']
      },
      {
        matches: [/\bhorchata/, /\borchata/],
        expansions: ['horchata']
      },
      {
        matches: [/\blavanda/, /\blavender/],
        expansions: ['lavanda', 'lavender']
      },
      {
        matches: [/\bcanela/, /\bcinnamon/],
        expansions: ['canela', 'cinnamon']
      },
      {
        matches: [/\bcoco\b/, /\bcoconut/],
        expansions: ['coco', 'coconut']
      },
      {
        matches: [/\bdurazno/, /\bpeach/, /\bmelocot[oó]n/],
        expansions: ['durazno', 'peach']
      },
      {
        matches: [/\btamarindo/, /\bchamoy/],
        expansions: ['tamarindo', 'chamoy']
      },
      {
        matches: [/\blim[oó]n/, /\blima\b/, /\blemon/, /\blime\b/],
        expansions: ['limón', 'lima', 'lemon']
      }
    ],

    isAcademyIntent(value) {
      const normalized = this.normalize(value);
      return this.academyFamilies.some((family) => family.matches.some((pattern) => pattern.test(normalized)));
    },

    getMatchedFamilies(value) {
      const normalized = this.normalize(value);
      return [...this.academyFamilies, ...this.catalogFamilies].filter(
        (family) => family.matches.some((pattern) => pattern.test(normalized))
      );
    },

    quote(term) {
      return term.includes(' ') ? `"${term}"` : term;
    },

    expandQuery(value) {
      const original = String(value || '').trim();

      if (!original) return original;

      const matchedFamilies = this.getMatchedFamilies(original);

      if (!matchedFamilies.length) return original;

      const expandedTerms = [original];
      matchedFamilies.forEach((family) => {
        family.expansions.forEach((term) => expandedTerms.push(term));
      });

      const uniqueTerms = [...new Set(expandedTerms.map((term) => term.trim()).filter(Boolean))];

      if (uniqueTerms.length === 1) return original;

      return uniqueTerms.map((term) => this.quote(term)).join(' OR ');
    }
  };
}

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.closest('form');
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.addListeners();
      this.init();
    }

    addListeners() {
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.resetBtn.addEventListener('click', this.handleReset.bind(this));
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }

    init() {
      this.restoreOriginalSearchTerm();

      if ((this.input.dataset.placeholderTwo || this.input.dataset.placeholderThree)
        && (this.input.dataset.placeholderPromptsMob === 'true' || theme.mediaMatches.md)) {
        this.typeInPlaceholders();
      }
    }

    restoreOriginalSearchTerm() {
      const params = new URLSearchParams(window.location.search);
      const originalQuery = params.get('oq');

      if (!originalQuery) return;

      this.input.value = originalQuery;
      this.input.setAttribute('value', originalQuery);
      this.input.classList.add('search__input--dirty');

      const searchTermChip = document.querySelector('.results-summary__chip--search-term');
      if (searchTermChip) {
        searchTermChip.textContent = `"${originalQuery}"`;
      }
    }

    /**
     * Simulates the placeholder titles being typed in and the previous one deleted, on repeat
     */
    typeInPlaceholders() {
      const typingSpeed = this.input.dataset.typingSpeed || 100;
      const deletingSpeed = this.input.dataset.deletingSpeed || 60;
      const delayAfterDeleting = this.input.dataset.delayAfterDeleting || 500;
      const delayBeforeFirstDelete = this.input.dataset.delayBeforeFirstDelete || 2000;
      const delayAfterWordTyped = this.input.dataset.delayAfterWordTyped || 2400;
      const placeholders = [];

      if (this.input.placeholder) {
        placeholders.push(this.input.placeholder);
      }

      if (this.input.dataset.placeholderTwo) {
        placeholders.push(this.input.dataset.placeholderTwo);
      }

      if (this.input.dataset.placeholderThree) {
        placeholders.push(this.input.dataset.placeholderThree);
      }

      const typeInNextPlaceholder = async (placeholder) => {
        await new Promise((resolve) => {
          let currentPlaceholder = this.input.getAttribute('placeholder');

          // If necessary remove the start of the word to type in if it already exists in the
          // placeholder
          let nextPlaceholder = (currentPlaceholder.length >= 3
              && placeholder.startsWith(currentPlaceholder))
            ? placeholder.replace(currentPlaceholder, '')
            : placeholder;

          const typingIntervalId = setInterval(() => {
            currentPlaceholder = this.input.getAttribute('placeholder');
            this.input.setAttribute('placeholder', currentPlaceholder + nextPlaceholder.charAt(0));
            if (nextPlaceholder.length === 1) {
              resolve();
              clearInterval(typingIntervalId); // Stop typing
            } else {
              nextPlaceholder = nextPlaceholder.substring(1);
            }
          }, typingSpeed);
        });
      };

      const deleteCurrentPlaceholder = async (nextPlaceholder) => {
        await new Promise((resolve) => {
          let prevPlaceholder = this.input.getAttribute('placeholder');
          const deletionIntervalId = setInterval(() => {
            const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
            this.input.setAttribute('placeholder', newPlaceholder);
            prevPlaceholder = newPlaceholder;
            if (prevPlaceholder.length === 0
              || (prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder))) {
              resolve();
              clearInterval(deletionIntervalId);
            }
          }, deletingSpeed);
        });
      };

      let startIndex = 0;
      const showNextPlaceholder = () => {
        startIndex = (startIndex + 1) % placeholders.length;
        const nextPlaceholder = placeholders[startIndex];
        deleteCurrentPlaceholder.call(this, nextPlaceholder).then(() => {
          setTimeout(() => {
            typeInNextPlaceholder.call(this, nextPlaceholder).then(() => {
              setTimeout(showNextPlaceholder.bind(this), delayAfterWordTyped);
            });
          }, delayAfterDeleting);
        });
      };

      setTimeout(showNextPlaceholder.bind(this), delayBeforeFirstDelete);
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      if (this.input.value.length > 0) {
        this.input.classList.add('search__input--dirty');
      } else {
        this.input.classList.remove('search__input--dirty');
      }
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
    }

    /**
     * Handles the reset button being clicked
     */
    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }

    handleSubmit(evt) {
      const originalQuery = this.input.value.trim();
      const expandedQuery = window.kexSearchSemantic.expandQuery(originalQuery);

      if (!originalQuery || expandedQuery === originalQuery) return;

      let originalQueryInput = this.form.querySelector('input[name="oq"]');
      if (!originalQueryInput) {
        originalQueryInput = document.createElement('input');
        originalQueryInput.type = 'hidden';
        originalQueryInput.name = 'oq';
        this.form.appendChild(originalQueryInput);
      }

      originalQueryInput.value = originalQuery;
      this.input.value = expandedQuery;
      this.input.setAttribute('value', expandedQuery);

      queueMicrotask(() => {
        if (!evt.defaultPrevented) return;

        this.input.value = originalQuery;
        this.input.setAttribute('value', originalQuery);
      });
    }
  }

  customElements.define('search-form', SearchForm);
}
